module.exports = "/assets/data/2c6911525571d52804c7fecdeb93b784-G14.data.json";